import { API_URL } from "../utils/AppApiUrl";
import { post } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";

const DeleteSpareImgService = async (baseURL, requestBody) => {
  try {
    
    const DeleteResponse = await post(
      tokenHttpClient,          
      `${baseURL}${API_URL.spareDeletImg}`,
      requestBody     
    );
    if (DeleteResponse.status === 200) {
      return DeleteResponse;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export default DeleteSpareImgService;
